var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('alert'),_c('keep-alive',{attrs:{"max":2,"include":_vm.include}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }